import { EXTRACT_AS_CATEGORIES } from '@avisoma/shared/dist/api-schema/paths/extract-as-categories.js';

const EXTRACTOR_CATEGORIES = new Set<string>(EXTRACT_AS_CATEGORIES);

/**
 * Overlay-only completion with no stored primary (DR-4703).
 * A missing `primaryRan` is a legacy stamp. Do not treat it as a skip.
 * A page hash next to `primaryRan: false` means a primary result is still
 * the authority. The entity stage has no hash field.
 *
 * The same stamp covers a low-confidence extractor category and a category
 * that has no extractor. Name the floor only when the stamped category is
 * an extractor category. That is the only skip left in that case.
 */
export function primaryExtractionSkippedReason(category: string | undefined): string {
  if (category !== undefined && EXTRACTOR_CATEGORIES.has(category)) {
    return 'Primary extraction skipped: classification confidence <= 0.75.';
  }
  return 'Primary extraction skipped.';
}

export function pagePrimaryExtractionSkipped(
  stage:
    | {
        status?: string;
        primaryRan?: boolean;
        extractorHash?: string | null;
      }
    | null
    | undefined,
): boolean {
  if (stage == null) return false;
  return stage.status === 'done' && stage.primaryRan === false && stage.extractorHash == null;
}

export function entityPrimaryExtractionSkipped(
  stage:
    | {
        status?: string;
        primaryRan?: boolean;
      }
    | null
    | undefined,
): boolean {
  if (stage == null) return false;
  return stage.status === 'done' && stage.primaryRan === false;
}
